export default function announce(message) {
  if($('#etl-ps-screen-reader-announce').length === 0) {
    $('body').append('<div id="etl-ps-screen-reader-announce" class="etl-ps-visually-hidden" aria-live="polite" aria-atomic="true"></div>')
  }

  $('#etl-ps-screen-reader-announce').text(message);
}
